import React, { Component } from 'react';
import BackButton from '../lib/BackButton';
import CandidateDetail from '../lib/CandidateDetail';
import Dropdown from '../lib/Dropdown';
import { sortCandidates } from '../lib/sorting';
import '../../scss/RaceDetail.scss';

import Moment from 'react-moment';

export default class RaceDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: {value: 'bio', label: 'Bio'}
    };
  }
  
  changeIssue(selected) {
    this.setState({ selected });
  }

  render() {
    let { router: { match: { params }, location: { state } }, allRaces } = this.props;
    let { issue, selected } = this.state;
    
    let options;
    let race = allRaces[params.race];
    let previousPath = state && state.previous || '/';

    if (race.issues) {
      options = race.issues && race.issues.map(i => ({value: i.key, label: i.display}));
      options.unshift({value: 'bio', label: 'Bio'});
    }
    let raceLabel = race.seat === 'Mayor' ? 'Mayoral' : race.seat;
    
    if (!race.candidates) {
      return (
        <div className="RaceDetail">
          <BackButton path={previousPath} />
          <h3>No Candidates for this race</h3>
        </div>
      );
    }
    return (
      <div className="RaceDetail">
        <BackButton path={previousPath} />
        <h2 className="RaceDetail__header">
          {race.seat}
        </h2>
        {race.issues &&
          <div className="RaceDetail__controls">
            <h3 className="RaceDetail__subhead">Bio + Key Issues</h3>
            
            <Dropdown
              options={options}
              onChange={this.changeIssue.bind(this)}
              value={this.state.selected} />
          </div>
        }
        <div className="RaceDetail__body">
          {sortCandidates(race.candidates).map((c, i) => <CandidateDetail candidate={c} issue={selected.value} key={i} />)}
        </div>
        
        <div className="RaceDetail__footer">
          {race.stories &&
            <div className="RaceDetail__stories">
              <h3 className="RaceDetail__header">More on this Race</h3>
              {race.stories.map((story, i) => {
                return (
                  <div key={i} className="RaceDetail__story">
                    <h4 className="RaceDetail__story-title">{story.description}</h4>
                    (<a href={story.link} target="_blank">{story.credit}, <Moment parse="MM/D" date={story.date} format="MMMM D" /></a>)
                  </div>
                );
              })}
            </div>
          }
          <BackButton pill={true} path={previousPath} />
        </div>
        
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/src/js/routes/RaceDetail.js